@if (field) {
  <div class="modal fade" id="edit-user-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        @if (field === 'job') {
          <div class="modal-body">
            <label>Position <span class="text-danger small">(required)</span></label>
            <select class="form-control" [ngClass]="setClassInvalidTpl(job)"
              name="job" #job="ngModel" [(ngModel)]="user.job" required>
              <option value="" selected disabled>Select job</option>
              @for (job of jobs; track job) {
                <option [value]="job">{{job}}</option>
              }
            </select>
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="!user.job" (click)="updateUser(field)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}